module.exports = __webpack_public_path__ + "static/media/students1.6d735ce4.svg";